import {computed, override, observable} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {LivePenaltiesModuleConfig} from "../live-penalties-module.config";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module/competitor-players-stats-module.consts";
import {AthleteEventsChartDataSource} from "../../../domain/athlete-events-chart/athlete-events-chart.data-source";
import {AthleteChartEventsDomainModel} from "../../../domain/full-game/models/chart-events/athlete-chart-events/athlete-chart-events.domain-model";
import {AthleteChartEventsViewModel} from "../../../domain/full-game/models/chart-events/athlete-chart-events/athlete-chart-events.view-model";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {AthleteViewModel} from "../../../domain/common/athlete/athlete-view-model";

export class LivePenaltiesModuleState extends BaseModuleState {
  dataSource: AthleteEventsChartDataSource;
  @observable selectedPlayerIndex: Number = 0;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, LivePenaltiesModuleConfig];

  @override get isPopulated(): Boolean {
    return this.dataSource;
  }

  @computed get athletesChartEvents(): Array<AthleteChartEventsViewModel> {
    const athletesChartEvents: Array<AthleteChartEventsViewModel> = this.dataSource?.chartEventsModels?.map((player: AthleteChartEventsDomainModel) => new AthleteChartEventsViewModel(player));

    return athletesChartEvents;
  }

  @computed get activeItemWidth(): Number {
    const activeItemWidth: Number = this.device.isSmallView ? COMPETITOR_PLAYER_STATS.DESIGN.PLAYER_LOGO_SIZE.mobile : COMPETITOR_PLAYER_STATS.DESIGN.PLAYER_LOGO_SIZE.desktop;

    return activeItemWidth;
  }

  @computed get competitorVM(): CompetitorViewModel {
    const competitorVM: CompetitorViewModel = new CompetitorViewModel(this.props.competitor);

    return competitorVM;
  }

  @computed get selectedAthleteChartEvent(): AthleteChartEventsViewModel {
    return this.athletesChartEvents ? this.athletesChartEvents[this.selectedPlayerIndex] : this.athletesChartEvents?.first();
  }

  @computed get title(): String {
    return `${this.competitorVM?.name} - ${this.terms.WEB_PENALTY_POPUP_PENALTY_AWARDED}`;
  }

  @computed get selectedAthlete(): AthleteViewModel {
    return this.selectedAthleteChartEvent?.athlete
  }
}
